/*
 * File: AppLayout.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/10/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Component for the overall structure/layout
 * of the application.
 */

import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import { useIdleTimer } from "react-idle-timer";

import AuthenticatedRoutes from "./AuthenticatedRoutes";
import Topbar from "./Topbar";
import { useAppStore } from "stores/AppStore";
import useStayAlive from "../hooks/useStayAlive";

const useStyles = makeStyles({
  appWrapper: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  container: {
    display: "flex",
    height: "100vh",
    overflow: "hidden"
  },
  content: {
    flex: "1 0 auto",
    overflow: "auto"
  }
});

const AppLayout = () => {
  const classes = useStyles();
  const app = useAppStore();
  const history = useHistory();

  useStayAlive();

  useIdleTimer({
    timeout: 60000 * 5,
    onIdle: async () => {
      await app.auth.logout();
      history.push("/");
    },
    debounce: 250
  });

  return (
    <div className={classes.appWrapper}>
      <Topbar appName={app.appName} />

      <div className={classes.container}>
        <div className={classes.content}>
          {app.auth.portalUser && (
            <AuthenticatedRoutes user={app.auth.portalUser} />
          )}
        </div>
      </div>
    </div>
  );
};

export default observer(AppLayout);
